import { Formik, Form } from "formik";
import { FormModel } from "../types/FormTypes";
import { useAtom } from "jotai";
import { formDataAtom } from "../App";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { useRef } from "react";
import useFocusOnLoad from "../hooks/useFocusOnLoad";

import {
  Box,
  Button,
  handleSubmitClick,
  ErrorList,
  Progressbar,
  InputText,
  Heading,
} from "@ogt/ui";

export default function TicketWithApp() {
  const h2Ref = useFocusOnLoad<HTMLHeadingElement>();
  const [formData, setFormData] = useAtom(formDataAtom);
  const navigate = useNavigate();
  const formRef = useRef<HTMLFormElement>(null);
  const progress = 33;
  return (
    <div>
      <Formik<FormModel>
        onSubmit={(values) => {
          setFormData({
            ...formData,
            ...values,
          });

          navigate("/vad-var-det-som-hande");
        }}
        initialValues={{
          ...formData,
        }}
        enableReinitialize
        validateOnChange={false}
        validateOnBlur={false}
        validationSchema={Yup.object().shape({
          ticketNumber: Yup.string().required(
            "Vänligen fyll i det mobilnummer som används i appen."
          ),
        })}
      >
        {({ errors, values }) => (
          <>
            <div className="flex justify-end items-center">
              <div className="w-full max-w-xs mb-4">
                <Progressbar percentage={progress} />
              </div>
            </div>

            <Form noValidate>
              <Box>
                <Heading
                  progress={progress}
                  headingRef={h2Ref}
                  focusable
                  id="appTicketHeading"
                >
                  Biljetten fanns i appen
                </Heading>

                <p>
                  För att gå vidare behöver vi ha det mobilnummer som är kopplat
                  till appen där biljetten fanns.
                </p>

                {Object.keys(errors).length > 0 && (
                  <ErrorList errors={errors} />
                )}

                <InputText
                  name="ticketNumber"
                  label={
                    <>
                      Mobilnummer <span>(Obligatoriskt)</span>
                    </>
                  }
                  type="tel"
                  autocomplete={"tel"}
                  numbersOnly
                />
              </Box>

              <div className="flex justify-center">
                <div className="w-full text-left flex items-center">
                  <Button
                    iconPosition="left"
                    iconSize={16}
                    iconName="arrow-left"
                    aria-label="Tillbaka"
                    showIcon
                    size="medium"
                    variant="outline"
                    onClick={(event) => {
                      event.preventDefault();
                      const backUrl = undefined;
                      if (backUrl) {
                        navigate(backUrl, { replace: true });
                      } else {
                        navigate(-1);
                      }
                    }}
                  >
                    Tillbaka
                  </Button>
                </div>
                <div className="w-full text-right">
                  <Button onClick={handleSubmitClick(formRef)} type="submit">
                    Gå vidare
                  </Button>
                </div>
              </div>
            </Form>
          </>
        )}
      </Formik>
    </div>
  );
}
